import React, { forwardRef, useContext, useEffect, useState, useCallback } from "react";

import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useData } from "../../contexts/DataContext";
import { UserContext } from "../../contexts/UserContext";
import AgentList from "../entities/agents/AgentList";
import AgentInfo from "./agentComponents/AgentInfo";
import AgentStatistics from "./agentComponents/AgentStatistics";
import AgentTabs from "./agentComponents/AgentTabs";

const EntityContainer = forwardRef((props) => {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      useState,
      "& .MuiTextField-root": {
        minWidth: 200,
        width: "100% !important",
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
      "& .MuiFormControlLabel-root": {
        margin: 0,
      },
    },
  }));
  const classes = useStyles();
  let history = useHistory();
  const [agentInfo, setAgentInfo] = useState();
  const [agentStats, setAgentStats] = React.useState();


  useEffect(() => {
    getAgentInfo();
  }, [props.match.params.id]);



  const getAgentStatistics = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Agent/Agent_GetStatistics?idAgent=${props.match.params.id}`;

    return axios.get(url).then((response) => {
      setAgentStats(response.data);
      return response.data;
    });

  }, [props.match.params.id]);

  useEffect(() => {
    getAgentStatistics();
  }, [getAgentStatistics]);

  const getAgentInfo = () => {
    const timeout = setTimeout(() => {
      axios({
        method: "post",
        url:
          process.env.REACT_APP_API2_URL +
          "/Agent/Agent_GetInfoByID?idAgent=" +
          props.match.params.id,
        /*  REPLACE WITH SELECT DATA */
      })
        .then((response) => response)
        .then((data) => {
          setAgentInfo(data.data);
        });
      return () => clearTimeout(timeout);
    });
  };

  const setCurrentAgent = (profile) => {
    console.log('profile=====>', profile)
    // setAgentInfo(profile);
    let anothervar = profile.idAgent.toString();
    //let anothervar = 'profile.IdProfile';
    history.push(anothervar);
  };

  //subscribeToTimer((err, timestamp) => settimestamp(timestamp));

  const {
    data: { fullscreen },
  } = useData();

  return (
    <React.Fragment>
      {agentInfo && (
        <>
          {!fullscreen && (
            <div className="sticky top-0 flex-grow-0">
              <AgentList setAgentInfo={setCurrentAgent}></AgentList>
            </div>
          )}
          <div className="flex-1 min-w-0">
            <Paper className={`${classes.root} flex flex-col gap-4`}>
              <div
                id="inputs"
                style={{
                  display:
                    "flex flex-col items-center justify-center text-center",
                }}
              >
                <AgentInfo
                  key={agentInfo?.idAgent}
                  AgentInfo={agentInfo}
                  getAgentInfo={getAgentInfo}
                ></AgentInfo>
              </div>
              <AgentTabs
                AgentInfo={agentInfo}
                getAgentStatistics={getAgentStatistics}
                getAgentInfo={getAgentInfo}
              ></AgentTabs>
            </Paper>
          </div>
          {agentInfo && !fullscreen && (
            <div className="flex-grow-0 h-max">
              <AgentStatistics
                AgentInfo={agentInfo}
                agentStats={agentStats}
                setAgentInfo={setCurrentAgent}
                getAgentStatistics={getAgentStatistics}
              />
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
});

export default EntityContainer;
